import * as React from "react"
import {
  Edit
} from "react-admin"
import UserForm from "./UserForm"

const UserTitle = () => {
  return <span>{'帳號'}</span>;
};

const UserEdit = () => (
    <Edit 
      title={<UserTitle/>} 
      redirect={false} 
      mutationMode="optimistic"
    >
      <UserForm 
        formType="edit" 
      />
    </Edit>
)

export default UserEdit